/**
 * siteOrgAPI — Lot 3, 3.1 : l'organigramme des sites et les droits (`site_org_routes.mjs`).
 *
 * Client UNIQUE de ce domaine : ne JAMAIS lire/écrire `user_site_access` ou
 * `working_site.parent_site_id` par un autre chemin (le CRUD générique sur
 * `user_site_access` est ouvert en lecture à tout utilisateur authentifié, sans contrôle de
 * rôle — c'est exactement ce que ces routes dédiées referment).
 *
 * @module api/siteOrg
 */
import { apiRequest } from './core.js';

export const siteOrgAPI = {
  /** Arbre de l'organisation (bornée au périmètre de l'appelant), compteurs, responsables directs. */
  getTree: () => apiRequest('/sites/tree'),

  /** Rattache (ou détache, `parentSiteId: null`) un site. */
  setParent: (siteId, parentSiteId) => apiRequest(`/sites/${siteId}/parent`, {
    method: 'PUT',
    body: JSON.stringify({ parent_site_id: parentSiteId }),
  }),

  /** Responsables d'un site : accès direct + hérité (d'un ancêtre). */
  getAccess: (siteId) => apiRequest(`/sites/${siteId}/access`),

  /** Accorde un accès sur un site. Idempotent côté serveur. */
  grantAccess: (siteId, userId) => apiRequest(`/sites/${siteId}/access`, {
    method: 'POST',
    body: JSON.stringify({ user_id: userId }),
  }),

  /** Retire un accès direct. Refusé si c'est le dernier accès de l'utilisateur (code LAST_ACCESS). */
  revokeAccess: (siteId, userId) => apiRequest(`/sites/${siteId}/access/${userId}`, {
    method: 'DELETE',
  }),
};

export default siteOrgAPI;
